<template>
  <div
    class="appointment-type-inner"
    v-show="appointmentType.selectedType !== 'event_appointment'"
  >
    <div
      class="custom-input-wrapper input-wrapper all-day-wrapper timing-wrapper office-loaction psybooks-video"
    >
      <label class="container-radio" @click="useConnect" v-show="connectUserId && connectUserId > 0">
        <span class="checkmark" :class="{ checked: usePsybooksVideo && useConnectVideo }"></span>
        PSYBooks Connect
      </label>
      <label class="container-radio" @click="useSv" v-show="videoUserId && videoUserId > 0">
        <span class="checkmark" :class="{ checked: usePsybooksVideo && !useConnectVideo }"></span>
        Secure Video
      </label>
      <label class="container-radio" @click="setOtherVideo">
        <span class="checkmark" :class="{ checked: !usePsybooksVideo && !useConnectVideo }"></span
        >Other Video
      </label>
    </div>
    <transition name="expand">
      <div
        class="custom-input-second input-wrapper all-day-wrapper timing-wrapper office-loaction psybooks-reminder"
        v-if="(usePsybooksVideo || useConnectVideo) && !isSame"
      >
        <label class="container-radio" @click="setVideoReminder('E')">
          <span
            class="checkmark"
            :class="{ checked: videoReminder === 'E' }"
          ></span>
          Email reminder
        </label>
        <label class="container-radio" @click="setVideoReminder('S')">
          <span
            class="checkmark"
            :class="{ checked: videoReminder === 'S' }"
          ></span>
          SMS reminder
        </label>
        <label class="container-radio" @click="setVideoReminder('N')">
          <span
            class="checkmark"
            :class="{ checked: videoReminder === 'N' }"
          ></span>
          No reminder
        </label>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { providerDependentMixin } from "../../../../mixins/providerDependentMixin";

export default {
  mixins: [providerDependentMixin],
  computed: {
    ...mapGetters({
      videoReminder: "getVideoReminder",
      usePsybooksVideo: "getUsePsybooksVideo",
      useConnectVideo: "getUseConnectVideo",
      edit: "getEdit",
      detail: "getDetail",
      appointmentType: "getAppointmentType"
    }),
    ...mapGetters({
      userRole: "getUserRole",
      videoUserId: "getVideoUserId",
      connectUserId: "getConnectUserId"
    }),
    isSame() {
      // Step 1: Check if edit
      if (!this.edit.isEdit) {
        return false;
      }

      // Step 2: Set the appointment
      const appointment = this.detail[this.edit.id];

      if (
        !!(appointment.is_connect) !== this.useConnectVideo ||
        !!(appointment.is_video) !== this.usePsybooksVideo
      ) {
        return false;
      } else {
        this.setVideoReminder(appointment.video_invitepref);
      }

      // Step 3: Person check
      if (this.appointmentType.selectedType === "person") {
        if (this.appointmentType.selectedId === appointment.client_id) {
          return true;
        }
        return false;
      }

      // Step 4: Other check
      if (appointment.client_id === 0) {
        // Step 4.1: Person check
        if (
          appointment.otherevent_type === 1 &&
          this.appointmentType.selectedType === "other_event"
        ) {
          if (this.appointmentType.selectedId === appointment.otherevent_id) {
            return true;
          }
          return false;
        }

        // Step 4.2: Group check
        if (
          appointment.otherevent_type === 2 &&
          this.appointmentType.selectedType === "group_appointment"
        ) {
          if (this.appointmentType.selectedId === appointment.otherevent_id) {
            return true;
          }
          return false;
        }
      }

      // Step 5: Other
      return false;
    }
  },
  methods: {
    ...mapMutations({
      setVideoReminder: "setVideoReminder",
      setUsePsybooksVideo: "setUsePsybooksVideo",
      setUseConnectVideo: "setUseConnectVideo"
    }),

    /**
     * Sets SV
     */
    useSv() {
      this.setUsePsybooksVideo(true);
      this.setUseConnectVideo(false);
    },

    /**
     * Sets Connect
     */
    useConnect() {
      this.setUsePsybooksVideo(true);
      this.setUseConnectVideo(true);
    },

    /**
     * Sets other video.
     */
    setOtherVideo() {
      this.setUsePsybooksVideo(false);
      this.setUseConnectVideo(false);
    }
  }
};
</script>

<style scoped>
.expand-enter-active {
  animation: expand 0.2s ease-in-out forwards;
}

.expand-leave-active {
  animation: contract 0.2s ease-in-out forwards;
}

div.custom-input-second {
  border-top: none;
  align-items: center;
  background-color: #f7f7f7;
  transform-origin: 0;
  border-bottom: none;
  display: flex;
  width: 100%;
}

div:last-of-type {
  border-bottom: 1px solid #d0d0d0;
}

div:hover {
  background-color: #f7f7f7;
}

label:first-of-type {
  margin-left: 7px;
}

@keyframes expand {
  from {
    opacity: 0;
    transform: scaleY(0);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

@keyframes contract {
  from {
    opacity: 1;
    transform: scaleY(1);
  }
  to {
    opacity: 0;
    transform: scaleY(0);
  }
}
</style>
